



































































































































import Vue from "vue";
import { InformationType, InformationTypeTree } from "@/common/models";
import { SharedState } from "@/common/state";
import { computed, onMounted, Ref, ref } from "@vue/composition-api";
import AppCheckbox from "@/components/AppCheckbox.vue";
import Modal from "@/components/root/modal/Modal.vue";
import { ModalConfig } from "@/components/root/modal";

export default Vue.extend({
  components: { Modal, AppCheckbox },
  props: ["modalData"],
  setup(props, { emit }) {
    const config: ModalConfig = {
      title: "",
      desc: "",
      blank: true,
      width: "54rem",
      height: "50rem",
      withTopRightCloseBtn: true,
    };
    const modal_data = computed(() => props.modalData as { labels: string[] });
    const info_types: Ref<InformationTypeTree[]> = ref([]);
    const initial_selected_labels: Ref<string[]> = ref([]);
    const selected_labels: Ref<InformationType[]> = ref([]);
    const indexed_selected_labels = computed(() =>
      selected_labels.value.reduce((acc, type) => {
        acc[type.id] = true;
        return acc;
      }, {} as Record<string, true>)
    );

    const filter_out_ms_labels = (tree: InformationTypeTree[]) => {
      return tree.map((branch) => {
        return {
          ...branch,
          nested: branch.nested
            ? branch.nested.filter((f) => f.id !== "ms")
            : [],
        };
      });
    };

    onMounted(() => {
      const tree = SharedState.get_raw_info_types_tree();
      selected_labels.value = modal_data.value.labels.map((l_id) => {
        return SharedState.getInfoType(l_id)!;
      });
      initial_selected_labels.value = [...modal_data.value.labels];
      info_types.value = filter_out_ms_labels(tree);

      // filter out the "Other" info type also
      info_types.value = info_types.value.filter(
        (f) => f.id !== SharedState.default_label_id.value
      );
    });

    const cancel = () => {
      selected_labels.value = initial_selected_labels.value.map((l_id) => {
        return SharedState.getInfoType(l_id)!;
      });
    };

    const save = () => {
      emit(
        "submit",
        selected_labels.value.map((d) => d.id)
      );
    };

    const has_changes = computed(() => {
      const key_start = modal_data.value.labels.sort().join("_");
      const key_current = selected_labels.value
        .map((d) => d.id)
        .sort()
        .join("_");
      return key_current != key_start;
    });

    const reached_max_selected_labels = computed(
      () => selected_labels.value.length >= 20
    );

    const check = (item: InformationTypeTree) => {
      console.log("status:", status);
      if (!reached_max_selected_labels.value) {
        selected_labels.value = [...selected_labels.value, item];
      }
    };

    const uncheck = (item: InformationTypeTree) => {
      selected_labels.value = selected_labels.value.filter(
        (f) => f.id !== item.id
      );
    };

    return {
      config,
      check,
      info_types,
      uncheck,
      save,
      cancel,
      selected_labels,
      indexed_selected_labels,
      has_changes,
      reached_max_selected_labels,
    };
  },
});
